import { render, staticRenderFns } from "./PlanModal.vue?vue&type=template&id=5b4558b2&scoped=true&"
import script from "./PlanModal.vue?vue&type=script&lang=js&"
export * from "./PlanModal.vue?vue&type=script&lang=js&"
import style0 from "./PlanModal.vue?vue&type=style&index=0&id=5b4558b2&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5b4558b2",
  null
  
)

export default component.exports